// E2E test hook identifiers — aligned to COM-902 selector contract.
// Prefer getByRole() / getByLabel() in Playwright tests; use data-testid only when needed.
// Naming convention: vf-[module]-[element] (kebab-case, deterministic).

// --- Workspaces ---

export const locatorsWorkspaces = {
    workspaceCard: (uuid) => `vf-workspaces-card-${uuid}`,
    addWorkspaceButton: 'vf-workspaces-add-button',
    workspaceActionsMenu: (uuid) => `vf-workspaces-actions-menu-${uuid}`,
};

// --- Sidebar menu ---

export const locatorsMenu = {
    toggleButton: 'vf-menu-toggle',
    queueItem: (uuid) => `vf-menu-queue-${uuid}`,
    searchItem: (uuid) => `vf-menu-search-${uuid}`,
    clientSection: (uuid) => `vf-menu-client-${uuid}`,
};

// --- Navigation tabs ---

export const locatorsNavigation = {
    workspaceTab: (uuid) => `vf-navigation-workspace-tab-${uuid}`,
    quickSearchTab: 'vf-navigation-quick-search-tab',
    tabCloseButton: (uuid) => `vf-navigation-tab-close-${uuid}`,
};

// --- Moderation list (queue/search header & controls) ---

export const locatorsModerationList = {
    headerName: 'vf-moderation-list-header-name',
    headerActionsMenu: 'vf-moderation-list-header-actions',
    bulkSelectAll: 'vf-moderation-list-bulk-select-all',
    bulkActionDropdown: 'vf-moderation-list-bulk-action-dropdown',
    addFilterButton: 'vf-moderation-list-add-filter',
    filterDropdown: (uuid) => `vf-moderation-list-filter-${uuid}`,
    sortFieldDropdown: 'vf-moderation-list-sort-field',
    sortOrderDropdown: 'vf-moderation-list-sort-order',
    previousPageButton: 'vf-moderation-list-previous-page',
    nextPageButton: 'vf-moderation-list-next-page',
};

// --- Content item (individual moderation content) ---

export const locatorsContent = {
    contentItem: (contentId) => `vf-content-item-${contentId}`,
    bulkCheckbox: (contentId) => `vf-content-bulk-checkbox-${contentId}`,
    actionsMenu: (contentId) => `vf-content-actions-menu-${contentId}`,
    assessmentButton: (contentId) => `vf-content-assessment-${contentId}`,
    addTagDropdown: (contentId) => `vf-content-add-tag-${contentId}`,
};

// --- Content moderation actions ---

export const locatorsContentActions = {
    assessmentApprove: (contentId) => `vf-content-approve-${contentId}`,
    assessmentReject: (contentId) => `vf-content-reject-${contentId}`,
};

// --- Profile panel ---

export const locatorsProfile = {
    profileDropdown: 'vf-profile-dropdown',
    viewCommentsButton: 'vf-profile-view-comments',
    viewProfileButton: 'vf-profile-view-profile',
    actionsMenu: 'vf-profile-actions-menu',
    banTrigger: 'vf-profile-ban-trigger',
    banDuration: 'vf-profile-ban-duration',
    banType: 'vf-profile-ban-type',
    banAdminMessage: 'vf-profile-ban-admin-message',
    banUserMessage: 'vf-profile-ban-user-message',
    banSubmit: 'vf-profile-ban-submit',
    ipLink: 'vf-profile-ip-link',
};

// --- Warning modal ---

export const locatorsModal = {
    warningCancel: 'vf-modal-warning-cancel',
    warningAction: 'vf-modal-warning-action',
};

// --- Note dropdown ---

export const locatorsNote = {
    toggle: 'vf-note-toggle',
    editButton: 'vf-note-edit',
    saveButton: 'vf-note-save',
    cancelButton: 'vf-note-cancel',
};

// --- Share overlay ---

export const locatorsShare = {
    overlay: 'vf-share-overlay',
    input: 'vf-share-input',
};

// --- Rename dropdown ---

export const locatorsRename = {
    input: 'vf-rename-input',
    submitButton: 'vf-rename-submit',
};

// --- Filter editor controls ---

export const locatorsFilterEditor = {
    applyButton: 'vf-filter-editor-apply',
    removeButton: 'vf-filter-editor-remove',
};

// --- Creation flow ---

export const locatorsCreationFlow = {
    saveButton: 'vf-creation-flow-save',
    closeButton: 'vf-creation-flow-close',
};

// --- New list actions (save/save-as) ---

export const locatorsNewListActions = {
    actionButton: (key) => `vf-new-list-action-${key}`,
};

// --- Quick create dropdown ---

export const locatorsQuickCreate = {
    dropdown: 'vf-quick-create-dropdown',
};

// --- Header ---

export const locatorsHeader = {
    userMenu: 'vf-header-user-menu',
};
